import $ from 'jquery';

export const apiCall = function(endpoint, method, payload) {
  const csrfToken =
    document.querySelector('meta[name="csrf-token"]').content || {};

  return $.ajax({
    url: endpoint,
    method,
    data: payload,
    contentType: 'application/json',
    headers: {
      'X-CSRF-Token': csrfToken,
    },
  });
};
